import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

import PhoneIcon from '@/assets/images/call-icon.svg';
import MailIconDim from '@/assets/images/dashicons_email-alt.svg';
import LocationIcon from '@/assets/images/location-icon.svg';
import MailIcon from '@/assets/images/mail-icon.svg';
import MFLLogo from '@/assets/images/mfl.png';
import MuthootCapitalLogo from '@/assets/images/muthoot-capital-logo.png';
import NormalArrow from '@/assets/images/normal_arrow.svg';
import PhoneIconDim from '@/assets/images/phone.svg';
import ProfileIcon from '@/assets/images/profile-icon.svg';
import { RegulatoryComplianceSEO } from '@/utils/constants/MetaData';

const RegulatoryCompliance = () => {
  const [showMC, setShowMC] = useState<boolean>(false);
  const [showMF, setShowMF] = useState<boolean>(false);

  const showDetails = (type: string) => {
    if (type == 'mc') {
      setShowMC(true);
      return;
    }
    if (type == 'mf') {
      setShowMF(true);
    }
  };
  return (
    <>
      <Head>
        <title>{RegulatoryComplianceSEO.metaTitle}</title>
        <meta
          name="description"
          content={RegulatoryComplianceSEO.metaDescription}
        />
        <meta
          property="og:description"
          content={RegulatoryComplianceSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/regulatory-compliance/"
        />
      </Head>
      <section className="guidelines-banner">
        <h1 className="banner-text">Regulatory-Digital Lending</h1>
        <div className="banner-cards-container">
          <div className="banner-card">
            <Link
              href="/privacy-policy"
              className="banner-header"
              id="regulatory_privacy"
            >
              <p>Privacy Policy</p>
              <Image
                style={{ color: undefined }}
                src={NormalArrow}
                alt="Privacy Policy"
              />
            </Link>
            <p className="banner-card-content">
              Learn how we handle your personal data, including collection, use,
              protection, and your rights, in accordance with applicable laws
              and regulations.
            </p>
          </div>
          <div className="banner-card">
            <a href="https://sachet.rbi.org.in/" className="banner-header">
              <p>RBI Sachet portal</p>
              <Image
                style={{ color: undefined }}
                src={NormalArrow}
                alt="RBI sanchet portal"
              />
            </a>
            <p className="banner-card-content">
              Learn how to simplify the process of lodging complaints related to
              deposits, schemes, and fake emails with relevant Regulator/Law
              Enforcement Authority.
            </p>
          </div>
        </div>
      </section>
      <section className="lending-partner-section">
        <div className="lending-partner-container">
          <p>Lending Partners</p>
          <p>
            Join our network of trusted lending partners and unlock new
            opportunities for business growth and financial success
          </p>
          <div className="lending-cards-container">
            <div className="lending-card">
              <Image
                style={{ color: undefined }}
                src={MuthootCapitalLogo}
                className="lender-logo"
                alt="Muthoot Capital Logo"
              />
              <span className="border-ver"></span>
              <div className="lending-text">
                <p>Muthoot Capital</p>
                <p>Personal Loan</p>
                <Link
                  onClick={() => showDetails('mc')}
                  href=""
                  className="link-blue"
                  id="regulatory_learn-more"
                >
                  Learn more
                </Link>
              </div>
            </div>
            <div className="lending-card">
              <Image
                style={{ color: undefined }}
                src={MFLLogo}
                className="lender-logo"
                alt="Muthoot Fincorp Logo"
              />
              <span className="border-ver"></span>
              <div className="lending-text">
                <p>Muthoot Fincorp Ltd</p>
                <p>MSME Loan</p>
                <Link
                  onClick={() => showDetails('mf')}
                  href=""
                  className="link-blue"
                  id="regulatory_msme_learn-more"
                >
                  Learn more
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-lightblue">
        <div className="grievance-section">
          <div>
            <p>Grievance redressal mechanism</p>
            <p>
              Customers who wish to provide feedback or send in their complaint
              may use the following channels between
              <span className="text-bold">
                09:00 am and 6:00 pm, on Monday to Saturday
              </span>
              (except on national holidays).
            </p>
          </div>
          <div>
            <p>Internal Machinery to handle the customer complaints.</p>
            <div className="grv-div1">
              <div className="grv-left">
                <p>Reach out to us</p>
                <span>
                  <Image
                    style={{ color: undefined }}
                    src={PhoneIcon}
                    alt="Call icon"
                  />
                  <a href="tel:18001021616">1800 102 1616 (Toll free)</a>
                </span>
                <span>
                  <Image
                    style={{ color: undefined }}
                    src={MailIcon}
                    alt="Email icon"
                  />
                  <a href="mailto:customercare@muthoot.com">
                    customercare@muthoot.com
                  </a>
                </span>
              </div>
              <div className="grv-right">
                <p>Our Office address</p>
                <span>
                  <Image
                    style={{ color: undefined }}
                    src={LocationIcon}
                    alt="Call icon"
                    className="address-icon"
                  />
                  <p>
                    <span className="text-bold">Muthoot FinCorp ONE: </span>
                    Muthoot FinCorp ONE, 315 Work Avenue KRM1, 2nd Floor, #32,
                    Hosur Rd, beside Nexus (Forum) Mall, Adugodi, Bengaluru,
                    Karnataka 560095
                  </p>
                </span>
                <span>
                  <Image
                    src={LocationIcon}
                    alt="Call icon"
                    className="address-icon"
                  />
                  <p>
                    <span className="text-bold">Muthoot FinCorp: </span>
                    Muthoot Centre, TC No 27/ 3022 Punnen Road
                    Thiruvananthapuram Thiruvananthapuram KL 695001 IN
                  </p>
                </span>
              </div>
            </div>
          </div>
          <div>
            <p>
              In case the complaint is not resolved within the given time or if
              he/she is not satisfied with the solution provided by MFL, the
              customer can approach the
              <span className="text-bold"> Grievance Officer:</span>.
            </p>
            <div className="grv-details">
              <span>
                <Image
                  style={{ color: undefined }}
                  src={ProfileIcon}
                  alt="profile icon"
                />
                <p>Ms. Julia Mathew</p>{' '}
              </span>
              <span>
                <Image
                  style={{ color: undefined }}
                  src={MailIconDim}
                  alt="email dash"
                />
                <p>
                  <a
                    href="mailto:Julia.mathew@muthoot.com"
                    className="text-grey"
                  >
                    Julia.mathew@muthoot.com
                  </a>
                </p>{' '}
              </span>
              <span>
                <Image
                  style={{ color: undefined }}
                  src={PhoneIconDim}
                  alt=" phone icon"
                />
                <p>
                  <a href="tel:0471-4911626" className="text-grey">
                    0471-4911626
                  </a>
                </p>
              </span>
            </div>
            <p>
              *Contact between
              <span className="text-bold">
                09.00 am to 6.00 pm Monday to Saturday
              </span>
              (except on National Holidays)
            </p>
          </div>
        </div>
      </section>
      {(showMC || showMF) && (
        <div className="lender-details-section-overlay">
          {showMC && (
            <section className="lender-details-section">
              <Image
                style={{ color: undefined }}
                src={NormalArrow}
                onClick={() => setShowMC(false)}
                alt="normal arrow"
              />
              <div className="lender-header">
                <Image
                  style={{ color: undefined }}
                  src={MuthootCapitalLogo}
                  alt="MuthootCapital Logo"
                  width={100}
                />
                <div>
                  <p className="lender-header-text">Muthoot Capital</p>
                  <p className="lender-header-subtext">Lending Partner</p>
                </div>
              </div>
              <div className="lender-redressal-details">
                <p className="redressal-header">Grievance/redressal details:</p>
                <div className="redressal-det">
                  <img
                    src="../assets/icons/pl/loc-icon-light.svg"
                    alt="location icon"
                  />
                  <span>
                    <p>Address</p>
                    <p>
                      Muthoot Capital Services Limited, 3rd Floor, Muthoot
                      Towers, MG Road, Kochi – 682 035
                    </p>
                  </span>
                </div>
                <div className="redressal-det">
                  <img
                    src="../assets/images/dashicons_email-alt.svg"
                    alt="email dash"
                  />
                  <span>
                    <p>Email</p>
                    <p>
                      <a
                        href="mailto:care@muthootcap.com"
                        className="text-grey"
                      >
                        care@muthootcap.com
                      </a>
                    </p>
                  </span>
                </div>
                <div className="redressal-det">
                  <img
                    src="../assets/icons/pl/web-icon-light.svg"
                    alt="web icon"
                  />
                  <span>
                    <p>Website</p>
                    <p>
                      <a
                        href="https://www.muthootcap.com/"
                        className="text-grey"
                      >
                        https://www.muthootcap.com/
                      </a>
                    </p>
                  </span>
                </div>
              </div>
            </section>
          )}
          {showMF && (
            <section className="lender-details-section">
              <Image
                style={{ color: undefined }}
                src={NormalArrow}
                onClick={() => setShowMF(false)}
                alt="Normal Arrow"
              />
              <div className="lender-header">
                <Image
                  style={{ color: undefined }}
                  src={MFLLogo}
                  alt="MFLL logo"
                />
                <div>
                  <p className="lender-header-text">Muthoot Fincorp Limited</p>
                  <p className="lender-header-subtext">Lending Partner</p>
                </div>
              </div>
              <div className="lender-redressal-details">
                <p className="redressal-header">Grievance/redressal details:</p>
                <div className="redressal-det">
                  <img
                    src="../assets/icons/pl/loc-icon-light.svg"
                    alt="location icon"
                  />
                  <span>
                    <p>Address</p>
                    <p>Muthoot Centre, Punnen road, Trivandrum- 695 039</p>
                  </span>
                </div>
                <div className="redressal-det">
                  <img
                    src="../assets/images/dashicons_email-alt.svg"
                    alt="email dash"
                  />
                  <span>
                    <p>Email</p>
                    <p>
                      <a
                        href="mailto:customercare@muthoot.com"
                        className="text-grey"
                      >
                        customercare@muthoot.com
                      </a>
                    </p>
                  </span>
                </div>
                <div className="redressal-det">
                  <img
                    src="../assets/icons/pl/web-icon-light.svg"
                    alt="web icon"
                  />
                  <span>
                    <p>Website</p>
                    <p>
                      <a
                        href="https://www.muthootfincorp.com/"
                        className="text-grey"
                      >
                        https://www.muthootfincorp.com/
                      </a>
                    </p>
                  </span>
                </div>
              </div>
            </section>
          )}
        </div>
      )}
    </>
  );
};

export default RegulatoryCompliance;
